import { useCallback } from 'react';
import { useAutomationRuleActions } from '../actions/use-actions';
import { ActionItemType, EditWorkItemActionType } from '../actions/types';

export function useDatetimeInputWithActions() {
	const {actions, setActions} = useAutomationRuleActions();

	const onChangeDateTime = useCallback((actionId: string) => (date: Date) => {
		setActions(oldActions => {
			const current = oldActions.find(item => item.id === actionId) as ActionItemType;
			const others = oldActions.filter(item => item.id !== actionId);
			const editWorkItemValues = current.editWorkItem as EditWorkItemActionType;

			return [...others, {
				...current, editWorkItem: {
					...current.editWorkItem as EditWorkItemActionType,
					dateTimeValue: {
						...editWorkItemValues.dateTimeValue,
						type: 'datetime',
						datetime: {
							value: date,
						},
					},
				}
			}];
		});
	}, [actions]);

	const onChangeTimeframe = useCallback((actionId: string) => (timeframe: {
		timeNumber: number;
		timeUnit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
		timeOption: 'ago' | 'from-now';
	}) => {
		setActions(oldActions => {
			const current = oldActions.find(item => item.id === actionId) as ActionItemType;
			const others = oldActions.filter(item => item.id !== actionId);
			const editWorkItemValues = current.editWorkItem as EditWorkItemActionType;

			return [...others, {
				...current, editWorkItem: {
					...current.editWorkItem as EditWorkItemActionType,
					dateTimeValue: {
						...editWorkItemValues.dateTimeValue,
						type: 'timeframe',
						timeframe: {
							...editWorkItemValues.dateTimeValue.timeframe,
							...timeframe,
						},
					},
				}
			}];
		});
	}, [actions]);

	return {
		onChangeDateTime,
		onChangeTimeframe
	};
}